import script from "./DataTableForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./DataTableForm.vue?vue&type=script&lang=ts&setup=true"

import "./DataTableForm.vue?vue&type=style&index=0&id=537dce22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-537dce22"]])

export default __exports__